const CREATED = 'CR';
const WAITING_REVIEW = 'WR';
const IN_REVIEW = 'IN_REVIEW';
const CONFIRMED = 'CF';
const REVIEWED = 'REVIEWED';
const REJECTED = 'RJ';
const LEARNED = 'LEARNED';
const PROCESSING = 'IP';
const EXCEPTION = 'EXCEPTION';
const EXPORTED = 'EX';
const MERGED = 'MR';
const REJECTED_FOR_USER = 'RU';

export default {
  WAITING_REVIEW,
  IN_REVIEW,
  REVIEWED,
  REJECTED,
  LEARNED,
  PROCESSING,
  EXCEPTION,
  CONFIRMED,
  CREATED,
  EXPORTED,
  MERGED,
  REJECTED_FOR_USER,
};
